import { motion } from 'framer-motion';
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from './ui/accordion';

const faqs = [
  {
    question: 'Was kostet eine AZAV-Beratung?',
    answer: 'Die Kosten hängen vom Umfang Ihres Vorhabens ab. Für eine Trägerzulassung rechnen Sie mit einem mittleren vierstelligen Betrag. Auditvorbereitungen oder laufende QM-Betreuung beginnen im dreistelligen Bereich pro Monat. Im Erstgespräch klären wir Ihren Bedarf und Sie erhalten ein konkretes Angebot.'
  },
  {
    question: 'Wie lange dauert eine Trägerzulassung?',
    answer: 'Bei vollständigen Unterlagen und zügiger Zusammenarbeit ist eine Zulassung in 8–12 Wochen realistisch. Die eigentliche Bearbeitungszeit bei der FKS beträgt meist 4–6 Wochen. Entscheidend ist die Qualität der eingereichten Dokumente.'
  },
  {
    question: 'Können Sie auch kurzfristig vor einem Audit helfen?',
    answer: 'Ja. Wir bieten kurzfristige Auditorvorbereitungen an. Innerhalb von wenigen Tagen prüfen wir Ihre Dokumentation, identifizieren Lücken und bereiten Sie gezielt auf typische Auditorfragen vor.'
  },
  {
    question: 'Was passiert bei Abweichungen im Audit?',
    answer: 'Abweichungen sind kein Weltuntergang. Wir helfen Ihnen, diese strukturiert zu bearbeiten und fristgerecht nachzuweisen. Unser Ziel ist es jedoch, Abweichungen durch gute Vorbereitung von vornherein zu vermeiden.'
  },
  {
    question: 'Übernehmen Sie auch das interne Audit?',
    answer: 'Ja. Das jährliche interne Audit ist Pflicht für jeden AZAV-Träger. Wir führen es professionell durch, dokumentieren die Ergebnisse und leiten bei Bedarf Korrekturmaßnahmen ein.'
  },
  {
    question: 'Bieten Sie einen externen QM-Beauftragten an?',
    answer: 'Ja. Als externer QM-Beauftragter übernehmen wir die laufende Betreuung Ihres Qualitätsmanagements. Das umfasst Dokumentationspflege, interne Audits und die Kommunikation mit FKS und AMDL.'
  }
];

export const FAQ = () => {
  return (
    <section data-testid="faq-section" className="py-24 md:py-32 bg-[#F5F5F5] relative">
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Section Header */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-16"
        >
          <span className="text-sm uppercase tracking-widest text-primary font-semibold mb-4 block" data-testid="faq-caption">
            Häufige Fragen
          </span>
          <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-semibold tracking-tight mb-6 text-[#050505]" data-testid="faq-headline">
            Fragen und Antworten
          </h2>
        </motion.div>

        {/* FAQ Accordion */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5, delay: 0.2 }}
        >
          <Accordion type="single" collapsible className="space-y-4" data-testid="faq-accordion">
            {faqs.map((faq, index) => (
              <AccordionItem 
                key={index} 
                value={`item-${index}`}
                className="bg-white border border-[#E5E5E5] rounded-xl px-6 data-[state=open]:border-primary/50 data-[state=open]:shadow-md transition-all"
                data-testid={`faq-item-${index}`}
              >
                <AccordionTrigger className="text-left font-heading font-medium text-[#050505] hover:text-primary transition-colors py-6 [&[data-state=open]>svg]:rotate-180">
                  {faq.question}
                </AccordionTrigger>
                <AccordionContent className="text-[#555555] leading-relaxed pb-6">
                  {faq.answer}
                </AccordionContent>
              </AccordionItem>
            ))}
          </Accordion>
        </motion.div>
      </div>
    </section>
  );
};
